module.exports = __webpack_public_path__ + "img/dose-juice-j_YWoV_uzRw-unsplash.d046575b.jpg";